import { render } from "./ModalModificarEfector.vue?vue&type=template&id=72993516&scoped=true"
import script from "./ModalModificarEfector.vue?vue&type=script&lang=js"
export * from "./ModalModificarEfector.vue?vue&type=script&lang=js"

import "../assets/general.css?vue&type=style&index=0&id=72993516&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72993516"]])

export default __exports__